module.exports = __webpack_public_path__ + "static/media/download-icon.47040503.svg";